import { GET } from '..'


export const getCertificationInfo = () => {
  return GET(`/api/public/certification-info`)
}
